import React from 'react';
import './Button.css';

export function Button({ children, variant = 'primary', ...props }) {
  return (
    <button className={`styled-button ${variant}`} {...props}>
      {children}
    </button>
  );
}

export default Button;